import { JSONSchema7 } from 'json-schema';
import JSONSchema7Properties from '../jSONSchema7Properties';
import PageState from '../pageState';

export default (page: PageState): string[] => {
  const pageSchema = (page.schema.properties as JSONSchema7Properties)[
    'page'
  ] as JSONSchema7;

  const pageProperties = pageSchema.properties as JSONSchema7Properties;

  const pageRoles: string[] = [];

  Object.getOwnPropertyNames(pageProperties).forEach((propName: string) => {
    if (propName.includes('role')) {
      pageRoles.push(pageProperties[propName].title as string);
    }
  });

  return pageRoles;
};
